<template>
  <!-- Full-bleed layout: no side nav, header, toolbar or footer.
       Renders only the routed page so views like the dispatch map can
       take the whole viewport while staying inside the SPA. -->
  <div class="blank-layout">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'BlankLayout',
  // App.vue passes these to every layout; declared so they don't leak onto
  // the root element as attributes.
  props: {
    title: { type: String, default: '' },
    isXSmall: { type: Boolean, default: false },
    isLarge: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.blank-layout {
  height: 100vh;
  width: 100%;
  overflow: hidden;
}
</style>
